// extracted by mini-css-extract-plugin
export default {"menuItems":"MoreOptionsMenu_menuItems__fGost","menuItem":"MoreOptionsMenu_menuItem__Z7yLy"};